module.exports = __webpack_public_path__ + "static/media/ly.dc22bd4b.svg";